import lazyWithRetry from "../../../utils/lazyWithRetry";
const Drivers = lazyWithRetry(() => import("./Drivers/Drivers"));
const TeamMembers = lazyWithRetry(() => import("./TeamMembers/TeamMembers"));
const Roles = lazyWithRetry(() => import("./Roles/Roles"));

export { Drivers, TeamMembers, Roles };
